module.exports = __webpack_public_path__ + "static/media/1-Rakha.ac2c4f25.webp";